'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var client = require('@apollo/client');
var graphql = require('./graphql.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const OrderTrackingContext = /*#__PURE__*/React__namespace.createContext({
  query: null,
  getCurrentShipment: () => null,
  setCurrentShipment: () => {},
  mainShipmentId: null
});
const OrderTrackingProvider = ({
  value: {
    onUnauthenticatedRequest,
    queryVariables
  },
  children
}) => {
  const [mainShipmentId, setMainShipmentId] = React__namespace.useState(null);
  const query = client.useQuery(graphql["default"], {
    notifyOnNetworkStatusChange: true,
    variables: {
      retailerMoniker: queryVariables.retailerMoniker,
      trackingNumbers: queryVariables.trackingNumbers,
      orderNumbers: queryVariables.orderNumbers,
      versionName: queryVariables.versionName,
      carrier: queryVariables.carrier ?? 'generic',
      type: queryVariables.type,
      orderType: queryVariables.orderType,
      orderApiEnabled: queryVariables.orderApiEnabled,
      localeCountry: queryVariables.localeCountry,
      localeLanguage: queryVariables.localeLanguage,
      destinationZip: queryVariables.destinationZip,
      email: queryVariables.email,
      phone: queryVariables.phone,
      secured: queryVariables.secured,
      originZip: queryVariables.originZip,
      originCountry: queryVariables.originCountry,
      destinationCountry: queryVariables.destinationCountry,
      service: queryVariables.service,
      orderDate: queryVariables.orderDate,
      shipDate: queryVariables.shipDate,
      retailerDcId: queryVariables.retailerDcId,
      productCategory: queryVariables.productCategory,
      promiseDate: queryVariables.promiseDate,
      mainShipmentId: queryVariables.mainShipmentId,
      token: queryVariables.token,
      cache: queryVariables.cache,
      experienceHost: queryVariables.experienceHost || 'NARVAR',
      url: queryVariables.url,
      eddFormatTranslationKeys: [],
      shipmentHistoryDateFormatTranslationKeys: [{
        sameDay: 'shippingActivitySameDayDateFormat',
        lastDay: 'shippingActivityLastDayDateFormat',
        nextDay: 'shippingActivityNextDayDateFormat',
        lastWeek: 'shippingActivityLastWeekDateFormat',
        nextWeek: 'shippingActivityNextWeekDateFormat',
        sameElse: 'shippingActivitySameElseDateFormat'
      }, {
        sameDay: 'shippingActivitySameDayTimeFormat',
        lastDay: 'shippingActivityLastDayTimeFormat',
        nextDay: 'shippingActivityNextDayTimeFormat',
        lastWeek: 'shippingActivityLastWeekTimeFormat',
        nextWeek: 'shippingActivityNextWeekTimeFormat',
        sameElse: 'shippingActivitySameElseTimeFormat'
      }]
    }
  });
  const getMainShipmentId = React__namespace.useCallback(() => {
    // Shipment ID is first found on the orderTracking response. Once users start
    const mainShipmentIdOnOrderData = query?.data?.orderTracking.orders[0].mainShipmentId;
    return mainShipmentId || mainShipmentIdOnOrderData;
  }, [query, mainShipmentId]);
  const getCurrentShipment = React__namespace.useCallback(() => {
    const {
      shipments
    } = query?.data?.orderTracking.orders[0] || {};
    const id = getMainShipmentId();
    if (!id || !shipments) return null;
    const shipment = shipments.find(({
      shipmentId
    }) => shipmentId === id);
    return shipment || null;
  }, [query, getMainShipmentId]);
  const setCurrentShipment = React__namespace.useCallback(mainShipmentId => {
    setMainShipmentId(mainShipmentId);
  }, [setMainShipmentId]);
  const {
    unauthenticatedRequest,
    redirectUrl
  } = query.data?.orderTracking.orders[0] || {};
  if (unauthenticatedRequest && redirectUrl && onUnauthenticatedRequest) {
    onUnauthenticatedRequest(redirectUrl);
    return null;
  }
  return /*#__PURE__*/React__namespace.createElement(OrderTrackingContext.Provider, {
    value: {
      query,
      getCurrentShipment,
      setCurrentShipment,
      mainShipmentId: getMainShipmentId()
    }
  }, children);
};
var index = () => React__namespace.useContext(OrderTrackingContext);

exports.orderTrackingQuery = graphql["default"];
exports.OrderTrackingContext = OrderTrackingContext;
exports.OrderTrackingProvider = OrderTrackingProvider;
exports["default"] = index;
